import utils from "../utils";
export default {
  data() {
    return {
      uploadApi: "/api/common/s3/upload",
      limit: 5,
      // accept: "image/jpeg,image/jpg,image/png",
      headers: {},
      params: { folderType: 0 },
      listObj: {},
      fileList: [],
      imgQuality: 0.7,
      canClick: true
    };
  },
  computed: {
    ...mapState({
      messageImgs: state => state.chat.messageImgs,
      isConversation: state => state.isConversation,
      isSend: state => state.isSend,
      domain: state => state.domain,
      isShowEvaluatePage: state => state.isShowEvaluatePage
    })
  },
  mounted() {
    const headerData = utils.getRequestHeader();
    this.headers = { ...headerData };
    this.dragUploadImg();
  },
  watch: {
    // isSend() {
    //   this.fileList = this.messageImgs; //始终保持一致
    // }
  },
  methods: {
    handleSuccess(response = {}, file, fileList) {
      this.canClick = true;
      const {
        name,
        uid,
        url,
        response: { data }
      } = file;

      if (response.code == 200) {
        console.log(this, "this");
        this.$store.commit("setState", {
          // more: false,
          isshowsend: true
        });
        this.listObj[uid] = data[0].url;
        const addFocusEventInput = document.querySelector(".addFocusEvent");
        addFocusEventInput && addFocusEventInput.focus();
        const { path: imgUrl } = data[0]; //取出图片地址
        this.more = false;
        //用户聊天处 如果图片传送成功 将后端返回的数据存储在store中
        if (imgUrl) {
          this.$store.commit("chat/setState", {
            messageImgs: this.messageImgs.concat([
              { ...data[0], uid, localPath: imgUrl, name, url }
            ])
          });
        }
        this.$store.commit("setState", {
          isMsgUpload: false,
          isSend: false
        });
        // let obj = { ...data[0], uid, localPath: imgUrl, name, url };
        // this.fileList = JSON.stringify([...this.fileList, obj]);
      } else {
        this.$store.commit("setState", {
          isMsgUpload: false
        });
        const index = fileList.findIndex(item => item.uid === file.uid);
        fileList.splice(index, 1);
        if (response.code == "306") {
          //文件无效（0kb），请重新选择正确文件
          this.$message.error(response.msg);
        } else {
          this.$message.error("上传失败! 请重新上传！");
        }
      }
      this.$store.commit("setState", {
        isclickimg: false
      });
    },
    handleRemove(file) {
      const uid = file.uid;
      delete this.listObj[uid];
      console.log(file, "filess");
      //用户聊天处 从store中移除聊天上传的图片
      // this.fileList = this.fileList.filter(s => s.uid != uid);
      const index = this.fileList.findIndex(item => item.uid === file.uid);
      this.fileList.splice(index, 1);
      const s = this.messageImgs.filter(s => s.uid !== uid);
      this.$store.commit("chat/setState", {
        messageImgs: s
      });
      if (this.fileList.length == 0) {
        this.$store.commit("setState", {
          isMsgUpload: false,
          more: false,
          isshowsend: false
        });
      }
      // this.fileList = this.messageImgs;
      console.log(this.fileList, "状态");
      if (this.hideUploadEdit) {
        this.removeImg();
      }
    },
    beforeUpload(file) {
      console.log(file, "上传前");
      if (utils.isCustomer()) {
        this.$emit(
          "sendEnter",
          this.$customerConstant.CUSTOMER_CONSTANT.ENTERING
        );
      }
      var that = this;
      this.canClick = false;
      return new Promise((resolve, reject) => {
        const isJPG = file.type === "image/jpg";
        const isJPEG = file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        const isGIF = file.type === "image/gif";
        const isWEBP = file.type === "image/webp";
        const isLt1M = file.size / 1024 / 1024 < 1;
        const isLt10M = file.size / 1024 / 1024 > 10;
        let bool = false;
        console.log(isLt10M);
        if (isLt10M) {
          this.$store.commit("setState", {
            isMsgUpload: false
          });
          this.$message.closeAll();
          this.$message.error("图片太大,请压缩后上传");
          this.canClick = true;
          reject(false);
        }
        // let msg = "";
        if (isJPG || isPNG || isJPEG || isGIF || isWEBP) {
          //判断是否符合格式要求
          bool = true;
        } else {
          this.$store.commit("setState", {
            isMsgUpload: false
          });
          this.$message.closeAll();
          that.$message.error("上传文件必须是jpg、png、jpeg、gif、webp格式!");
          this.canClick = true;
          reject(false);
        }
        // if (file.size <= 0) {
        //   that.$message.error("文件无效（0kb），请重新选择正确文件");
        //   this.canClick = true;
        //   reject(false);
        // }
        // if (this.fileList.length > 8) {
        //   this.$store.commit("setState", {
        //     isMsgUpload: false
        //   });
        //   that.$message.error(`图片数量超出限制，最多上传${9}张`);
        //   reject(false);
        // }
        if (bool && !isLt1M) {
          //如果格式符合要求，但是size过大，对图片进行处理
          let image = new Image(),
            resultBlob = "";
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.$store.commit("setState", {
              isMsgUpload: true
            });
            resultBlob = that.compressUpload(image); //Blob
            file.width = resultBlob.width;
            file.height = resultBlob.height;
            resolve(resultBlob);
          };
        } else if (bool && isLt1M) {
          let image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.$store.commit("setState", {
              isMsgUpload: true
            });
            (file.width = image.width), (file.height = image.height);
            resolve(file);
          };
        }
      });
    },
    handleExceed() {
      this.$message.error(`图片数量超出限制，最多上传${this.limit}张`);
      this.$store.commit("setState", {
        isclickimg: false
      });
    },
    handleError() {
      this.$store.commit("setState", {
        isMsgUpload: false
      });
      this.$message.warning("网络/其他异常，上传失败，请重新上传!");
      this.$store.commit("setState", {
        isclickimg: false
      });
    },
    compressUpload(image) {
      let canvas = document.createElement("canvas"); //创建画布元素
      let ctx = canvas.getContext("2d");
      // let initSize = image.src.length;
      let { width } = image,
        { height } = image;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      let compressData = canvas.toDataURL("image/jpeg", 0.5); //等比压缩
      let obj = {};

      obj.blobImg = this.dataURItoBlob(compressData); //base64转Blob
      obj.width = width;
      obj.height = height;
      return obj;
    },
    dataURItoBlob(data) {
      let byteString;
      if (data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(data.split(",")[1]); //转二进制
      } else {
        byteString = unescape(data.split(",")[1]);
      }
      let mimeString = data
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    // 拖拽上传
    dragUploadImg() {
      const body = document.body;
      body.addEventListener("dragenter", e => {
        e.preventDefault();
      });

      body.addEventListener("dragover", e => {
        e.preventDefault();
      });

      body.addEventListener("drop", e => {
        e.stopPropagation();
        e.preventDefault();
        if (!this.isConversation) {
          return false;
        }
      });
    }
  },
  created() {
    //解决用户在聊天过程中 上传了图片 刷新之后图片消失 图片预览层还在的问题
    if (utils.isCustomer() && this.domain && this.domain.API_URL) {
      this.uploadApi = this.domain.API_URL + "/api/common/s3/upload";
    } else {
      this.uploadApi =
        process.env.VUE_APP_CUST_BASEURL + "api/common/s3/upload";
    }
    this.$store.commit("chat/setState", {
      messageImgs: []
    });
    this.fileList = [];
    this.$nextTick(() => {
      const dom = document.getElementsByClassName("el-upload-list")[0];
      dom.innerHTML = "";
    });
  }
};
